export default "__VITE_ASSET__DvP_rAwB__"